module.exports = __webpack_public_path__ + "img/macbook-02.29947dde.png";